// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import theme from '../../styled-components/dark';
import FlagIcon from '../FlagIcon';
import Link from '../Link';

const SubTitleWrapper = styled.div`
  margin-top: 0.3em;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledFlagIcon = styled(FlagIcon)`
  margin-right: 0.6em;
  height: 1em;
  width: 1em;
  vertical-align: middle;
  flex-shrink: 0;
`;

const SubtitleSharedStyle = css`
  color: ${theme.MatchCard.subTitle.color};
  font-size: 0.8em;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
`;

export const MatchSubTitleLabelClassName = 'match-subtitle-label';
const SubtitleLabel = styled.div`
  ${SubtitleSharedStyle}
`;

const SubtitleLink = styled(Link)`
  ${SubtitleSharedStyle}

  ${Target.__MOBILE__
    ? null
    : css`
        &:hover {
          color: ${theme.MatchCard.subTitle.hoverColor};
        }
      `}
`;

type PropsType = {
  className?: string;
  subTitle?: string;
  flagId?: string;
  redirection?: string;
};

const MatchSubTitle = ({ className, subTitle, flagId, redirection }: PropsType) => {
  return subTitle ? (
    <SubTitleWrapper className={className}>
      {flagId ? <StyledFlagIcon flagId={flagId} /> : null}
      {redirection ? (
        <SubtitleLink className={MatchSubTitleLabelClassName} to={redirection}>
          {subTitle}
        </SubtitleLink>
      ) : (
        <SubtitleLabel className={MatchSubTitleLabelClassName}>{subTitle}</SubtitleLabel>
      )}
    </SubTitleWrapper>
  ) : null;
};

export default MatchSubTitle;
